<template>
  <section class="mc-detail__advantages mc-advantages">
    <ul class="mc-advantages__list">
      <li class="mc-advantages__item">
        <img class="mc-advantages__icon" src="/assets/svg/icon-plane.svg" width="24" height="24" alt="">
        Доставка по России
      </li>
      <li class="mc-advantages__item">
        <img class="mc-advantages__icon" src="/assets/svg/icon-clock-check.svg" width="24" height="24" alt="">
        15 минут на примерку
      </li>
      <li class="mc-advantages__item">
        <img class="mc-advantages__icon" src="/assets/svg/icon-tag.svg" width="24" height="24" alt="">
        Высокое качество одежды
      </li>
      <li class="mc-advantages__item">
        <img class="mc-advantages__icon" src="/assets/svg/icon-refresh.svg" width="24" height="24" alt="">
        Легкий возврат
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  mounted() {

  },
  components: {},
  methods: {
  },
}
</script>

